import { TextContainer } from 'components/container'
import { Video } from 'components/video'

export const PageIntro = () => (
  <TextContainer>
    <p>
      Азатлык – свобода – не просто название площади в центре Казани, но и самое
      важное слово для татар. В современной России у татар мало возможностей
      бороться за свою идентичность, но есть люди, которые продолжают это делать
      несмотря ни на что.
    </p>
    <p>
      В этой серии мы встретим рэперов и продюсеров Yummi Music, организаторов
      самого масштабного фестиваля современной татарской музыки. Познакомимся с
      директором школы, которая несмотря на давление продолжает преподавать
      татарский язык. Поговорим с блогерками, которые вставили в свой российский
      паспорт национальный татарстанский вкладыш или решили отказаться от
      русифицированных окончаний в своих татарских фамилиях. Рассказываем, как
      живет Татарстан сегодня и как его жители популяризируют татарскую
      культуру:
    </p>

    <Video id="sB7gb_ivvMM" poster="https://gdb.currenttime.tv/01000000-c0a8-0242-56cb-08dc16024f94_w1920.jpg" />
  </TextContainer>
)
